export const environment = {
  production: true,
  baseUrl: 'https://api.sqa.mstrance.digital-nirvana.com/',
  wsEndpoint: 'wss://2aldhu0249.execute-api.us-east-1.amazonaws.com/sqa',
  environmentType: 'qa',
};
